import { Route, Routes, useParams } from 'react-router-dom';
import { Box } from '@mui/material';
import { UpdateProductDetails } from './UpdateProductDetails';
import { availableUpdateProductTabs } from '../../../variables/UpdateProduct';
import { UpdateProductTabs } from './UpdateProductTabs';

export const UpdateProductPageRoot = () => {
  const { productID: productIDAsStr } = useParams<string>();

  const productID = productIDAsStr ? Number(productIDAsStr) : undefined;

  return Number.isFinite(productID) ? (
    <Box>
      <UpdateProductTabs productID={productID!} />
      <Routes>
        {availableUpdateProductTabs.map((tab) => {
          const El = tab.element;

          return (
            <Route path={tab.path} element={<El productID={productID!} />} />
          );
        })}
        <Route
          path='*'
          element={<UpdateProductDetails productID={productID!} />}
        />
      </Routes>
    </Box>
  ) : (
    <Box>Geçersiz Ürün ID</Box>
  );
};
